import type React from 'react';
import { useRef, useEffect } from 'react';
type UseMakeMutable = <T>(referenceVar: T) => React.MutableRefObject<T>;

export const useMakeMutable: UseMakeMutable = (referenceVar) => {
  const mutable = useRef(referenceVar);
  useEffect(() => {
    mutable.current = referenceVar;
  }, [referenceVar]);
  return mutable;
};
